export const API_CONSTANTS = {
  FILES: '/files',
  FILES_COUNT: '/files/count',
  FIRMWARE_IMAGES: '/firmware-images',
  FIRMWARE_IMAGES_COUNT: '/firmware-images/count',
  FIRMWARE_IMAGES_UPLOAD: '/firmware-images/upload',
  JOBS: '/jobs',
  JOB_DEFINITIONS: '/job-definitions',
  LOGIN: '/users/login',
  LOGOUT: '/users/logout',
  TAGS: '/tags',
  TASKS: '/tasks',
  USERS: '/users',
  INVITE_USER: '/users/action'
};

export const CVE_DETAILS_URL = 'https://nvd.nist.gov/vuln/detail/';
export const LAST_ORG_USED_KEY = '|lastOrgUsedId';

// Keyed on email, because switching organization is exactly the case where the
// identity changes: one human on two SAML connections is samlp|connA|… in one
// org and samlp|connB|… in the other.  The email is the only thing stable
// across that change, so it is what carries the chosen org through the
// redirect - key on `sub` and the new identity reads a different slot, finds
// nothing, and lands wherever the login-time fallback happens to pick.
//
// `sub` is the fallback only when the token has no email, which happens when
// the Auth0 profile has none.  Without it the key collapsed to
// `undefined|lastOrgUsedId`, one slot shared by every user of the browser.
// The org a switch is heading for, held across the redirect that performs it.
// Deliberately not keyed on an identity: the auth gate reads it before there
// is a token to key on, which is the whole reason the gate could not name an
// organization on its redirect.  Session-scoped, so it dies with the tab
// rather than stranding a stale intent.
export const PENDING_ORG_KEY = 'nr.pendingOrg';

// The address to hand Auth0 with the pending org.  Without it an org-scoped
// redirect still stops at the identifier page to ask who the user is, which is
// the difference between a bounce off a warm IdP and a login prompt.
export const PENDING_HINT_KEY = 'nr.pendingOrgHint';

export const lastOrgUsedKeyFor = idToken => `${idToken?.email ?? idToken?.sub ?? ''}${LAST_ORG_USED_KEY}`;

// Auth0 sets the standard `org_id` claim on an org-scoped login through a
// database connection, but an enterprise SAML identity gets only the namespaced
// claim the login Action stamps.  Reading the bare one alone made the app treat
// every SAML user as having no organization, which is the enterprise-SSO case.
export const orgIdFrom = idToken =>
  idToken?.org_id ?? idToken?.[`${process.env.REACT_APP_AUTH0_NAMESPACE}org_id`];
